<template>
  <div class="home">
    <Toolbar/>
    <Map v-if="authentified"/>
    <Auth @authentify="authentify" v-if="!authentified"/>
  </div>
</template>

<script>
import Map from '@/components/Map'
import Auth from '@/components/Auth'
import Toolbar from '@/components/Toolbar'

export default {
  name: 'home',
  data () {
    return {
      authentified: false
    }
  },
  components: {
    Map,
    Auth,
    Toolbar
  },
  methods: {
    authentify (value) {
      this.authentified = value
    }
  }
}
</script>

<style>

.as-toolbar {
  background-color: #20202c !important;
}

.as-toolbar__item {
  background-color: #20202c !important;
}

.logo {
  margin-left: 10px;
  margin-top: 8px;
  width: 132px;
  height: 42px;
  border: none;
  background-size: 132px 28px;
  background-repeat: no-repeat;
  background-image: url('https://imagicglass.com/wp-content/uploads/2019/05/Telus.png');
}

body {
  background-color: #20202c !important;
}
</style>
